<template>
    <div class="features">
        <div class="page-header">
            <div class="title">{{ $t("settings.talkSettings") }}</div>
            <div class="subtitle">{{ $t("settings.talkSubtitles") }}</div>
        </div>
        <section>
            <div class="features">
                <FeatureItem
                    :title="feature.title"
                    :description="feature.description"
                    v-for="feature in features"
                    :value="readValue(feature.id)"
                    @input="setValue(feature.id, $event)"
                    :key="feature.id"
                    :icon="feature.icon"
                />
            </div>
        </section>
    </div>
</template>

<script>
import { mapState } from "vuex";
import log2 from "../../../../../utils/log2";
import WirelessKeyboardIcon from "../../../../../components/svg/icons/WirelessKeyboardIcon.vue";
import FeatureItem from "../../../Settings/components/FeatureItem.vue";
import MergeIcon from "../../../../../components/svg/icons/MergeIcon.vue";

const log = log2("Settings/Features");

export default {
    name: "TalkSettings",
    components: {
        WirelessKeyboardIcon,
        FeatureItem,
    },
    props: {
        updateSettings: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            features: [
                {
                    title: this.$t("message.customerTyping"),
                    description: this.$t("message.vtipyCustomerTyping"),
                    icon: "WirelessKeyboardIcon",
                    id: "writing",
                },
                {
                    title: this.$t("message.agentTyping"),
                    description: this.$t("message.vtipyAgentTyping"),
                    icon: "writingIcon",
                    id: "agentTyping",
                },
            ],
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        readValue(id) {
            log("readValue", id, this.settings[id]);
            if (["customerClientLanguageDetect", "subject", "autoTake", "writing", "bannedWord"].includes(id)) {
                return this.settings[id] == true;
            } else {
                return this.settings[id];
            }
        },
        setValue(id, value) {
            this.updateSettings(id, value);
        },
    },
    mounted() {},
    watch: {},
};
</script>

<style scoped lang="scss">
.features {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
</style>
